import { Paper, Stack, Typography } from '@mui/material'

export function StepImportant() {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        bgcolor: '#ffffff',
        p: { xs: 3, sm: 4, lg: 5 },
        boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
      }}
    >
      <Stack spacing={2.5} sx={{ maxWidth: 768, fontSize: { xs: 14, sm: 16 }, lineHeight: 1.625, color: '#1e293b' }}>
        <Typography
          component="h3"
          sx={{ fontSize: { xs: '1.125rem', sm: '1.25rem' }, fontWeight: 600, color: '#0f172a' }}
        >
          <span aria-hidden>🚨</span> Important <span aria-hidden>🚨</span>
        </Typography>

        <Typography sx={{ fontWeight: 700, fontSize: 'inherit', lineHeight: 'inherit' }}>
          It is essential that you remain current on all surplus lines tax filings and state
          reporting requirements.
        </Typography>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          Please note that MISC is not responsible for any reporting obligations during or prior to
          the implementation period.
        </Typography>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          <Typography component="span" sx={{ fontWeight: 700, fontSize: 'inherit' }}>
            Your Onboarding Checklist Assistant will stay active for 30 Days.
          </Typography>{' '}
          We encourage you to complete the requested information as soon as you can so we can
          schedule your Go-Live date and begin supporting your account.
        </Typography>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          <Typography component="span" sx={{ fontWeight: 700, fontSize: 'inherit' }}>
            You can save your progress and exit at anytime.
          </Typography>{' '}
          You can
          pick up where you left off by logging back into the wizard.
        </Typography>
        <Typography sx={{ fontSize: 'inherit', lineHeight: 'inherit' }}>
          If you need more than 30 days, just reach out to our team and we&apos;ll be happy to help
          with an extension.
        </Typography>
      </Stack>
    </Paper>
  )
}
